import { Backdrop, Box, Typography, Stepper, Step, StepLabel, StepContent, CircularProgress, Portal } from '@mui/material';
import { useEffect, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const steps = [
  'Initializing...',
  'Loading data...',
  'Processing information...',
  'Finalizing...',
  'Complete!'
];

const StepwiseLoader = () => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    if (activeStep < steps.length - 1) {
      const timer = setTimeout(() => {
        setActiveStep((prevStep) => prevStep + 1);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [activeStep]);

  return (
    <Portal>

      <Backdrop
        sx={{
          color: '#fff',
          zIndex: 9999999,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
        }}
        open={true}
      >
        <Box
          sx={{
            width: { xs: '90%', sm: '450px', md: '500px' },
            padding: 3,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: 2,
            backdropFilter: 'blur(10px)',
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
            sx={{ mb: 3 }}
          >
            <Box
              component="img"
              src="https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/images/png/profile.png"
              alt="Loading..."
              sx={{
                width: { xs: '50px', sm: '60px', md: '60px' },
                height: 'auto',
                animation: 'gentleBounce 2s ease-in-out infinite',
                '@keyframes gentleBounce': {
                  '0%, 100%': {
                    transform: 'translateY(0)',
                  },
                  '50%': {
                    transform: 'translateY(-5px)',
                  },
                },
              }}
            />
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>
              Processing...
            </Typography>
          </Box>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  StepIconComponent={() => {
                    if (index < activeStep) {
                      return <CheckCircleIcon sx={{ color: 'primary.main', fontSize: 28 }} />;
                    } else if (index === activeStep) {
                      return <CircularProgress size={24} sx={{ color: '#fff' }} />;
                    } else {
                      return <Box sx={{ width: 24, height: 24, borderRadius: '50%', border: '2px solid rgba(255, 255, 255, 0.3)' }} />;
                    }
                  }}
                >
                  <Typography sx={{ color: '#fff', fontWeight: index === activeStep ? 'bold' : 'normal' }}>
                    {label}
                  </Typography>
                </StepLabel>
                {index < steps.length - 1 && (
                  <StepContent>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', mt: 1 }}>
                      {index < activeStep ? 'Completed' : index === activeStep ? 'In progress...' : 'Pending'}
                    </Typography>
                  </StepContent>
                )}
              </Step>
            ))}
          </Stepper>
        </Box>
      </Backdrop>
    </Portal>
  );
};

export default StepwiseLoader;
